import type { TFunction } from 'i18next';

import { KB_SECTION_META } from '@/views/Dashboard/components/HelpAiChat/stefanSectionMeta';

import type { KbBuildLog, KbSection } from '../queries';

/** Nazwy zmienionych sekcji bazy wiedzy po polsku/angielsku/niemiecku, rozdzielone przecinkiem. */
export const kbLogSectionsLabel = (t: TFunction, log: KbBuildLog): string => log.sections
  .map((section) => {
    const meta = KB_SECTION_META[section as KbSection];
    return meta ? t(meta.labelKey, meta.labelFallback) : section;
  })
  .join(', ');

/**
 * Jedno zdanie o wpisie logu: co agent zrobił i czy się udało. Wspólne dla skróconej
 * listy w czacie „Zapytaj AI” i pełnej listy logów, żeby obie mówiły tym samym językiem.
 */
export const kbLogMessage = (t: TFunction, log: KbBuildLog, agentName: string | undefined): string => {
  const name = agentName?.trim() || t('helpAiChat.kbUpdates.agentFallback', 'Agent AI');
  if (!log.ok) {
    return t(
      'helpAiChat.kbUpdates.failed',
      'Nie udało się zaktualizować wiedzy agenta {{name}}. Spróbujemy ponownie przy następnej zmianie.',
      { name },
    );
  }
  if (log.sections.length > 0) {
    return t('helpAiChat.kbUpdates.learned', 'Agent {{name}} nauczył się zmian: {{sections}}', {
      name, sections: kbLogSectionsLabel(t, log),
    });
  }
  if (log.trigger === 'agentConfig' || log.trigger === 'agentKnowledge') {
    return t('helpAiChat.kbUpdates.settings', 'Agent {{name}} uwzględnił nowe ustawienia i wiedzę', { name });
  }
  return t('helpAiChat.kbUpdates.refreshed', 'Baza wiedzy agenta {{name}} jest aktualna', { name });
};
